import mitt from "mitt";
import { assertIsDefined } from "@utils/assertion";

export const HEADER_LOCKER_LOCKED = "locker-locked";
export const HEADER_LOCKER_TYPE = "locker-type";
export const HEADER_LOCKER_ID = "locker-id";
export const HEADER_LOCKER_LEASE = "locker-lease";

export const LockerType = {
  PPS_EDITOR: "PPS_EDITOR",
  CHANNEL_ADMIN: "CHANNEL_ADMIN",
  CONTENT_PRODUCTION_PIPELINE: "CONTENT_PRODUCTION_PIPELINE",
} as const;
export type LockerType = (typeof LockerType)[keyof typeof LockerType];

export type LockerKey = {
  lockerType: string;
  lockerId: string;
};

export type LockerLeaseReceivedEvent = {
  lockerKey: LockerKey;
  lockerLease: string;
};

export type LockerLockedEvent = {
  lockerKey: LockerKey;
};

type LockerEvents = {
  lockerLeaseReceivedEvent: LockerLeaseReceivedEvent;
  lockerLockedEvent: LockerLockedEvent;
};

export const lockerEventsEmitter = mitt<LockerEvents>(); //

export function handleLockerResponseHeaders(getHeader: (name: string) => string | null | undefined): void {
  const lockerType = getHeader(HEADER_LOCKER_TYPE);
  const lockerId = getHeader(HEADER_LOCKER_ID);
  const lockerLease = getHeader(HEADER_LOCKER_LEASE);

  if (lockerLease !== undefined && lockerLease !== null) {
    assertIsDefined(lockerType);
    assertIsDefined(lockerId);
    const event: LockerLeaseReceivedEvent = {
      lockerKey: { lockerType: lockerType, lockerId: lockerId },
      lockerLease: lockerLease,
    };
    lockerEventsEmitter.emit("lockerLeaseReceivedEvent", event);
  } else if (getHeader(HEADER_LOCKER_LOCKED) !== undefined && getHeader(HEADER_LOCKER_LOCKED) !== null) {
    assertIsDefined(lockerType);
    assertIsDefined(lockerId);
    const event: LockerLockedEvent = {
      lockerKey: { lockerType: lockerType, lockerId: lockerId },
    };
    lockerEventsEmitter.emit("lockerLockedEvent", event);
  }
}
